<template>
  <div class="container">

    <div class="column-75 page-middle">

      <hr>

      <h2>SHARE FOR +1 ENTRY!</h2>
      <h4>Share now to receive an additional sweepstakes entry.</h4>

      <div class="social-share facebook" @click="shareFb()" v-if="$store.state.stages.facebook_share"></div>

      <a :href="'https://twitter.com/intent/tweet?text='+$store.state.config.data.social_media.twitter.text" v-if="$store.state.stages.twitter_share">
        <div class="social-share twitter"></div>
      </a>

    </div>

  </div>
</template>

<script>

    import axios from 'axios'
    import {post_request, requests_methods, validation} from "../mixins/requests";

    export default {
        name: "social_share",
        mixins: [post_request, requests_methods, validation],
        computed: {
            this_page(){
                return this.$store.state.active_view
            }
        },
        methods: {
            twitter_init(){
                var scope = this;
                window.twttr = (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0],
                      t = window.twttr || {};
                    if (d.getElementById(id)) return t;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://platform.twitter.com/widgets.js";
                    fjs.parentNode.insertBefore(js, fjs);

                    t._e = [];
                    t.ready = function(f) {
                        t._e.push(f);
                    };

                    return t;
                }(document, "script", "twitter-wjs"));

                function tweetIntentToAnalytics(intentEvent){
                    scope.post_share(scope.$store.state.stages.twitter_share.all.methods.post.url,scope.$store.state.stages.twitter_share.fields.share.name) //request after sharing

                }

                window.twttr.ready(function (twttr) {
                    window.twttr.events.bind('tweet', tweetIntentToAnalytics);
                });

            },
            initFB: function(){
                //facebook widget
                window.fbAsyncInit = ()=>{
                    FB.init({
                        appId            : this.$store.state.config.data.social_media.facebook.app_id,
                        autoLogAppEvents : false,
                        xfbml            : false,
                        version          : 'v2.9'
                    });
                };

                (function(d, s, id){
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {return;}
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                } (document, 'script', 'facebook-jssdk'));
            },
            shareFb: function() {
                var scope = this;

                window.FB.ui({
                    method: 'share_open_graph',
                    action_type: 'og.likes',
                    display: 'dialog',
                    action_properties: JSON.stringify({
                        object: {
                            'og:url': scope.$store.getters.page_address,
                            'og:title': scope.$store.state.config.data.social_media.facebook.og_meta.title,
                            'og:description': scope.$store.state.config.data.social_media.facebook.og_meta.description,
                            'og:image': scope.$store.getters.page_address + 'fb_meta_image.jpg'
                        }
                    })
                }, function(response) {

                    var loginStatus = 'unknown';
                    window.FB.getLoginStatus(function(res){
                        if (typeof res.status !== 'undefined') {
                            loginStatus = res.status;
                        }
                    });
                    scope.post_share(scope.$store.state.stages.facebook_share.all.methods.post.url,scope.$store.state.stages.facebook_share.fields.share.name) //request after sharing
                });

            },
            post_share: function(url_post,field_name){
                var scope = this;
                let data= {
                    [field_name]: true
                }
                console.log('post share');
                console.log(data);

                axios.post(this.$store.state.API_ROUTE + url_post,data)
                  .then(function (response) {

                      if(response.data['data'].bonus_entry_received){
                          scope.show_modal('You Received 1 Extra Entry!')
                          console.log('You Received 1 Extra Entry!')
                      }else{
                          console.log('No Extra Entries Awarded.')
                      }

                  })
                  .catch(function (error) {

                  });

            }
        },
        created: function(){

        },
        mounted: function(){

            //this.initFB()
            //this.twitter_init()

        },
    }
</script>

<style scoped>
</style>